import customFieldTranslations from "@src/modules/member/modules/settings/custom-fields/_langs/en-US.ts";
import integrationsTranslations from "@src/modules/member/modules/settings/integrations/_langs/en-US";
import invoiceSettingsTranslations from "@src/modules/member/modules/settings/invoices/_langs/en-US.ts";
import organizationTranslations from "@src/modules/member/modules/settings/organization/_langs/en-US";
import profileTranslations from "@src/modules/member/modules/settings/profile/_langs/en-US";
import servicesTranslations from "@src/modules/member/modules/settings/services/_langs/en-US";
import timeEntriesTranslations from "@src/modules/member/modules/settings/time-entries/_langs/en-US";

export default {
  customFields: customFieldTranslations,
  back: "Back",
  invoices: invoiceSettingsTranslations,
  organization: organizationTranslations,
  profile: profileTranslations,
  integrations: integrationsTranslations,
  services: servicesTranslations,
  timeEntries: timeEntriesTranslations,
};
